import React, { useState, useEffect, useRef } from 'react'
import { Trans, Button } from '../../atoms'
import { Form, Formik, FieldArray } from 'formik'
import FormField from '../../atoms/FormField/FormField'
import FormInput from '../../atoms/FormInput/FormInput'
import { api } from '../../../utils'
import { useRouter } from 'next/router'
import Alert from '../../atoms/Alert/Alert'
import { AlertTriangleLine, Info } from '../../atoms/NewIcons'
import useTrans from '../../../hooks/useTrans'
import * as yup from 'yup'
import * as Sentry from '@sentry/browser'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

export const ModificaColori = ({
  personalizzazione,
  personalizzazioni_righe_equivalenti,
  ordine,
}) => {
  const t = useTrans()
  const router = useRouter()
  const lang = router.query.lang

  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const [uploading, setUploading] = useState(false)

  const onPantoniChange = async (values) => {
    setUploading(true)

    const body = {
      pantoni: values.pantoni,
    }

    try {
      const response = await api.put(
        `modifica-descrizione-colori-personalizzazione-ordine/${personalizzazione.id}/`,
        body,
        {
          params: {
            lang,
            ordine_id: ordine.id,
            personalizzazioni_equivalenti_ids: personalizzazioni_righe_equivalenti
              .filter((pers) => pers.id !== personalizzazione.id)
              .map((pers) => pers.id),
          },
        }
      )
      const data = await response.data

      setPantoniFromData(data)

      setErrorMessage('')
      setSuccessMessage('Colori modificati con successo')
    } catch (error) {
      setSuccessMessage('')
      setErrorMessage('Errore nel salvataggio dei colori')
      Sentry.captureException(error)
    }
    setUploading(false)
  }

  const [pantoni, setPantoni] = useState()

  const setPantoniFromData = (data) => {
    const pantoni = []
    data.forEach((pantone) => {
      pantoni.push(pantone.pantone)
    })
    setPantoni(pantoni)
  }

  useEffect(() => {
    if (!personalizzazione.numero_colori_posizione?.full_color) {
      const pantoni = Array(personalizzazione.numero_colori_posizione.numero_colori).fill('')
      if (personalizzazione.pantoni) {
        for (let i = 0; i < personalizzazione.pantoni.length; i++) {
          pantoni[i] = personalizzazione.pantoni[i].pantone
        }
      }
      setPantoni(pantoni)
    }
  }, [])

  const equalPantoni = (values) => {
    let equal = true
    pantoni.forEach((pantone, i) => {
      if (pantone !== values.pantoni[i]) {
        equal = false
        return
      }
    })
    return equal
  }

  return (
    <>
      {pantoni && pantoni.length !== 0 && (
        <div className="fp-edit-colori">
          {(errorMessage || successMessage) && (
            <div className="fp-edit-colori__alerts">
              {errorMessage && (
                <Alert placeholder={errorMessage} variant="error" icon={<AlertTriangleLine />} />
              )}
              {successMessage && (
                <Alert placeholder={successMessage} variant="info" icon={<Info />} />
              )}
            </div>
          )}
          <Formik
            initialValues={{
              pantoni: pantoni,
            }}
            enableReinitialize={true}
            onSubmit={(values) => {
              onPantoniChange(values)
            }}
            validateOnChange={true}
            validationSchema={yup.object().shape({
              pantoni: yup
                .array()
                .of(
                  yup
                    .string()
                    .required(t('Campo obbligatorio'))
                    .max(20, t('Massimo 20 caratteri'))
                    .nullable()
                )
                .required()
                .min(1),
            })}
          >
            {({ values, errors, touched, handleChange, setFieldValue, isValid }) => (
              <Form>
                <div className="fp-edit-colori__fieldsets">
                  {values.pantoni.length > 0 && (
                    <div className="fp-edit-colori__fieldsets">
                      {values.pantoni.map((pantone, index) => (
                        <FormField
                          label={`Pantone ${index + 1}`}
                          key={index}
                          status={
                            errors.pantoni?.[index]
                              ? 'error'
                              : touched.pantoni?.[index]
                              ? 'success'
                              : null
                          }
                          errorMessage={errors?.pantoni?.[index]}
                        >
                          <FormInput
                            type="text"
                            id={`pantoni.${index}`}
                            name={`pantoni.${index}`}
                            value={values.pantoni?.[index]}
                            placeholder="Inserisci colore"
                            onChange={(e) => {
                              setFieldValue(`pantoni[${index}]`, e.target.value)
                            }}
                          />
                        </FormField>
                      ))}
                    </div>
                  )}
                </div>
                <Button
                  type="submit"
                  label={t('Salva')}
                  variant="primary"
                  size="large"
                  disabled={!isValid || equalPantoni(values) || uploading}
                />
              </Form>
            )}
          </Formik>
        </div>
      )}
    </>
  )
}
